import styles from "./EnquiryForm.module.css";
import classNames from "classnames";
import buttonStyle from "./Button.module.css";
import { API_URL } from "../utils/data";
import { useRef, useState } from "react";
import TextareaField from "./TextareaField";
import InputField from "./InputField";
import RadioField from "./RadioField";
import HoneypotField from "./HoneypotField";

export default function EnquiryForm() {
  const formRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState([]);
  const [successMessage, setSuccessMessage] = useState(null);
  const HONEYPOT_FIELD = "fax";

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setErrors([]);
    setSuccessMessage(null);

    const formData = new FormData(formRef.current);
    const honeypot = formData.get(HONEYPOT_FIELD);
    if (typeof honeypot === "string" && honeypot.length > 0) {
      setSuccessMessage(
        "Thank you for your message. We'll be in touch shortly.",
      );
      formRef.current.reset();
      setIsSubmitting(false);
      return;
    } else {
      formData.delete(HONEYPOT_FIELD);
    }

    try {
      const response = await fetch(API_URL + "enquiries/", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        setSuccessMessage(
          "Thank you for your message. We'll be in touch shortly.",
        );
        formRef.current.reset();
      } else {
        setErrors(data);
      }
    } catch (error) {
      setErrors({
        nonFieldErrors: [
          "Sorry, something went wrong. Please try again later.",
        ],
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {successMessage ? (
        <p>{successMessage}</p>
      ) : (
        <>
          <p className={styles.intro}>
            Let us know a little bit about your project and we’ll be in touch to
            kick things off.
          </p>
          <form ref={formRef} onSubmit={handleSubmit}>
            <InputField
              disabled={isSubmitting}
              errorList={errors?.name}
              id="name"
              labelAlignment="center"
              labelText="Name"
              name="name"
              placeholder="Enter name"
              required={true}
              type="text"
              autoComplete="name"
            />
            <InputField
              disabled={isSubmitting}
              errorList={errors?.email}
              id="email"
              labelAlignment="center"
              labelText="Email"
              name="email"
              placeholder="Enter email"
              required={true}
              type="email"
              autoComplete="email"
            />
            <HoneypotField fieldName={HONEYPOT_FIELD} fieldType="text" />
            <RadioField
              disabled={isSubmitting}
              errorList={errors?.budget}
              items={["Under 10k", "10k-20k", "20k-50k", "50k-100k", "100k+"]}
              legendText="Budget"
              name="budget"
              required={true}
            />
            <RadioField
              disabled={isSubmitting}
              errorList={errors?.hasCashEquity}
              items={["yes", "no"]}
              legendText="Equity as cash"
              name="has_cash_equity"
              required={true}
            />
            <TextareaField
              disabled={isSubmitting}
              errorList={errors?.message}
              id="message"
              labelText="Message"
              name="message"
              placeholder="Enter message"
              required={true}
            />
            <button
              type="submit"
              className={classNames(styles.button, buttonStyle.button)}
            >
              {isSubmitting ? "Submitting" : "Submit"}
            </button>
          </form>
          <ul>
            {errors.nonFieldErrors &&
              errors.nonFieldErrors.map((error, index) => {
                return <li key={index}>{error}</li>;
              })}
          </ul>
        </>
      )}
    </>
  );
}
